import React, {Component} from "react"
import {connect} from "react-redux";
import {
    cancel_share,
    clear_cluster_error,
    create_cluster,
    get_clusters,
    remove_cluster,
    update_cluster
} from "../actions/clusters";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";

import {
    CardActions,
    CardHeader,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab,
    FormControlLabel,
    FormGroup,
    Menu,
    MenuItem,
    Tooltip
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import ButtonBase from '@mui/material/ButtonBase';
import SnackbarMessage from "./Custom/SnackbarMessage";
import AddIcon from '@mui/icons-material/Add';
import ClusterDialog from "./Dialogs/ClusterDialog";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClusterShareDialog from "./Dialogs/ClusterShareDialog";
import {set_page_title} from "../actions/navigation";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {resume_test, TEST} from "../actions/test";
import ImportDialog from "./Dialogs/ImportDialog";
import AIImportDialog from "./Dialogs/AIImportDialog";
import PsychologyIcon from '@mui/icons-material/Psychology';

const styles = {
    root: {
        marginTop: 15,
        marginLeft: 15,
        marginRight: 15,
        minHeight: "calc(100vh - 75px)",
        position: "relative"
    },
    buttonBase: {
        width: "100%",
        display: 'block',
        textAlign: 'initial'
    },
    fab: {
        position: 'fixed',
        bottom: "70px", // todo footer by sa mal nejako krajsie poriesit asi
        right: "10px",
    },
    fab2: {
        position: 'fixed',
        bottom: "150px", // todo footer by sa mal nejako krajsie poriesit asi
        right: "10px",
    },
    card: {
        position: 'relative'
    },
    cardDots: {
        position: 'absolute',
        top: "0",
        right: "0",
        zIndex: "999",
    },
    noMaxWidth: {
        maxWidth: 'none',
    },
    disabled_menu: {
        listStyle: "none",
        color: "inherit",
        border: 0,
        margin: 0,
        outline: 0,
        userSelect: "none",
        borderRadius: 0,
        verticalAlign: "middle",
        backgroundColor: "transparent",
        display: "flex",
        position: "relative",
        textAlign: "left",
        alignItems: "center",
        justifyContent: "flex-start",
        textDecoration: "none",
        paddingLeft: "16px",
        paddingRight: "16px",
        width: "auto",
        overflow: "hidden",
        fontSize: "1rem",
        boxSizing: "border-box",
        fontWeight: 400,
        lineHeight: 1.5,
        paddingTop: "6px",
        whiteSpace: "nowrap",
        letterSpacing: "0.00938em",
        paddingBottom: "6px",
        minHeight: "auto",
        opacity: 0.5,
        cursor: "auto",
        pointerEvents: "all",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
};

class Clusters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editOpen: false,
            aiImportOpen: false,
            createOpen: false,
            shareOpen: false,
            importOpen: false,
            editCluster: null,
            menuAnchorEl: null,
            removePrompt: null,
            cancelShareDialog: null,
            block_future_shares: false
        }
    }

    componentDidMount() {
        this.props.set_page_title("Clusters");
        this.props.get_clusters();
    }

    openCreateDialog() {
        this.props.clear_cluster_error();
        this.setState({
            ...this.state,
            editOpen: false,
            createOpen: true,
            shareOpen: false,
            importOpen: false,
            aiImportOpen: false,
            menuAnchorEl: null,
            cancelShareDialog: null
        });
    }

    openAiImportDialog() {
        this.props.clear_cluster_error();
        this.setState({
            ...this.state,
            editOpen: false,
            createOpen: false,
            shareOpen: false,
            importOpen: false,
            aiImportOpen: true,
            menuAnchorEl: null,
            cancelShareDialog: null
        });
    }

    openEditDialog() {
        this.props.clear_cluster_error();
        this.setState({
            ...this.state,
            editOpen: true,
            createOpen: false,
            shareOpen: false,
            importOpen: false,
            aiImportOpen: false,
            menuAnchorEl: null,
            cancelShareDialog: null
        });
    }

    openImportDialog() {
        this.props.clear_cluster_error();
        this.setState({
            ...this.state,
            editOpen: false,
            createOpen: false,
            shareOpen: false,
            importOpen: true,
            aiImportOpen: false,
            menuAnchorEl: null,
            cancelShareDialog: null
        });
    }

    exportCluster() {
        const link = document.createElement("a");
        link.style.display = "none";
        link.target = "_blank";
        link.setAttribute('download', this.state.editCluster.title + ".xlsx");
        link.href = this.state.editCluster.export;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    openShareDialog() {
        if (this.props.auth.user.premium) {
            this.setState({
                ...this.state,
                editOpen: false,
                createOpen: false,
                shareOpen: true,
                importOpen: false,
                menuAnchorEl: null,
                cancelShareDialog: null
            });
        }
    }

    closeDialogs() {
        this.setState({
            ...this.state,
            editOpen: false,
            createOpen: false,
            shareOpen: false,
            importOpen: false,
            menuAnchorEl: null,
            editCluster: null,
            cancelShareDialog: null
        });
        this.props.clear_cluster_error();
    }

    closeAiImportDialog() {
        this.setState({
            ...this.state,
            aiImportOpen: false,
        });
    }

    createCluster(info) {
        this.props.create_cluster(info.title, info.description, info.col_1_name, info.col_2_name, info.col_3_name, info.col_1_language === "-" ? null : info.col_1_language, info.col_2_language === "-" ? null : info.col_2_language, info.col_3_language === "-" ? null : info.col_3_language);
    }

    updateCluster(info) {
        this.props.update_cluster(info.id, info.title, info.description, info.col_1_name, info.col_2_name, info.col_3_name, info.col_1_language === "-" ? null : info.col_1_language, info.col_2_language === "-" ? null : info.col_2_language, info.col_3_language === "-" ? null : info.col_3_language);
    }

    removeCluster() {
        this.setState({
            ...this.state,
            removePrompt: this.state.editCluster
        });
    }

    openCancelShareDialog() {
        this.setState({
            ...this.state,
            cancelShareDialog: this.state.editCluster,
            block_future_shares: false
        });
    }

    cancelShareDialogClose() {
        this.setState({
            ...this.state,
            cancelShareDialog: null
        });
    }

    cancelShareDialogProceed() {
        const {block_future_shares, cancelShareDialog} = this.state;

        this.props.cancel_share(cancelShareDialog.id, block_future_shares).then((res) => {
            this.setState({
                ...this.state,
                cancelShareDialog: null
            });
            this.props.get_clusters();
        }).catch(err => {
        });
    }

    setBlockFutureShares(e) {
        this.setState({
            ...this.state,
            block_future_shares: e.target.checked
        });
    }

    remove_cluster_agree() {
        this.props.remove_cluster(this.state.editCluster.id);
        this.remove_cluster_close();
    }

    remove_cluster_close() {
        this.setState({
            ...this.state,
            removePrompt: null,
            editOpen: false,
            createOpen: false,
            shareOpen: false,
            menuAnchorEl: null,
            editCluster: null
        });
    }

    openMenu(event, cluster) {
        this.setState({...this.state, menuAnchorEl: event.currentTarget, editCluster: cluster});
    }

    closeMenu() {
        this.setState({...this.state, menuAnchorEl: null});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.clusters && prevProps.clusters) {
            // only if loaded
            if (this.props.clusters.length !== prevProps.clusters.length) {
                // when removed or added
                if (this.props.error == null) {
                    this.closeDialogs();
                }
            }
            /*if (this.props.clusters.length === prevProps.clusters.length) {
                // edit
                //let index= this.props.clusters.findIndex(cluster => cluster.id === this.state.editCluster.id);
                if (this.props.error == null && !this.state.shareOpen) {
                    this.closeDialogs();
                }
            }*/
        }
    }

    resumeTest(cluster_id) {
        this.props.resume_test();
        this.props.history.push('/clusters/' + cluster_id + '/test');
    }

    render() {
        const {classes} = this.props;

        if (this.props.clusters === null) {
            return <LinearProgress/>
        }

        const active_clusters_count = this.props.clusters.filter((c) => !c.disabled).length;

        let sorted_clusters = [
            ...this.props.clusters.filter((c) => !c.disabled),
            ...this.props.clusters.filter((c) => c.disabled),
        ];

        return (
            <div className={classes.root}>
                {this.props.clusters.length === 0 &&
                    <SnackbarMessage type="warning" message={"No clusters here"} autoHideDuration={null}
                                     anchorOrigin={false}/>}

                {this.props.clusters.length > 0 && <Grid container
                                                         spacing={3}
                                                         direction="row"
                                                         justifyContent="flex-start"
                                                         alignItems="flex-start"
                >
                    {sorted_clusters.map(function (cluster) {
                        const disabled_white = {background: "repeating-linear-gradient(-55deg, #fff, #fff 10px, #E0E0E0 10px, #E0E0E0 20px)"};
                        const disabled_black = {background: "repeating-linear-gradient(-55deg, #222, #222 10px, #333 10px, #333 20px)"};
                        const enabled_black = {background: "black"};
                        const enabled_white = {background: "white"};
                        return (
                            <Grid item xs={12} sm={6} key={cluster.id}>
                                <Card className={classes.card}
                                      elevation={0}
                                      style={cluster.disabled ? (
                                          this.props.theming.darkMode ? disabled_black : disabled_white
                                      ) : this.props.theming.darkMode ? enabled_black : enabled_white
                                      }
                                >
                                    {!cluster.disabled && (this.props.test.cluster_id !== cluster.id || this.props.test.state === TEST.NOT_RUNNING) &&
                                        <Tooltip enterTouchDelay={0}
                                                 title={<Typography>Cluster Manager</Typography>}
                                                 placement="left">
                                            <IconButton
                                                className={classes.cardDots}
                                                aria-label="settings"
                                                onClick={(e) => this.openMenu(e, cluster)}
                                                size="large">
                                                <MoreVertIcon/>
                                            </IconButton></Tooltip>}

                                    {!cluster.disabled && this.props.test.state === TEST.PAUSED && this.props.test.cluster_id === cluster.id &&
                                        <><CardHeader title={cluster.title}
                                                      subheader={cluster.description}>
                                        </CardHeader>
                                            <CardActions style={{justifyContent: "flex-end"}}>
                                                <Typography variant="caption">You have paused Learning & Practice
                                                    here.</Typography>
                                                <Button variant="contained" color="primary"
                                                        onClick={() => this.resumeTest(cluster.id)}>
                                                    Resume
                                                </Button>
                                            </CardActions>
                                        </>}
                                    {(cluster.disabled || !(this.props.test.state === TEST.PAUSED && this.props.test.cluster_id === cluster.id)) &&
                                        <ButtonBase
                                            className={classes.buttonBase}
                                            disabled={cluster.disabled}
                                            onClick={() => {
                                                this.props.history.push('/clusters/' + cluster.id + '/')
                                            }}
                                        >
                                            <CardHeader title={cluster.title}
                                                        subheader={cluster.description}
                                                        titleTypographyProps={{variant: "h6"}}
                                            >
                                            </CardHeader>
                                        </ButtonBase>}

                                </Card>
                            </Grid>
                        );
                    }.bind(this))}
                </Grid>}


                {<Dialog
                    open={Boolean(this.state.removePrompt)}
                    onClose={this.remove_cluster_close.bind(this)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this cluster?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            The cluster will be permanently deleted without the possibility of recovery.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.remove_cluster_close.bind(this)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.remove_cluster_agree.bind(this)} color="secondary" autoFocus
                                variant="contained">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>}

                {<Dialog
                    open={Boolean(this.state.cancelShareDialog)}
                    onClose={this.cancelShareDialogClose.bind(this)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle
                        id="alert-dialog-title">{"Are you sure you want to cancel sharing of this cluster?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            The cluster will be permanently deleted without the possibility of recovery.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{justifyContent: "space-between"}}>
                        <FormGroup row style={{padding: "0px 14px"}}>
                            <FormControlLabel
                                control={<Checkbox checked={this.state.block_future_shares}
                                                   onChange={this.setBlockFutureShares.bind(this)} name="checkedA"/>}
                                label="Block this user future sharing"
                            />
                        </FormGroup>
                        <div>
                            <Button onClick={this.cancelShareDialogClose.bind(this)} color="primary"
                                    style={{marginRight: 10}}>
                                Cancel
                            </Button>
                            <Button onClick={this.cancelShareDialogProceed.bind(this)} color="secondary" autoFocus
                                    variant="contained">
                                Proceed
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>}

                {this.state.importOpen && <ImportDialog open={true} cluster={this.state.editCluster}
                                                        handleClose={this.closeDialogs.bind(this)}/>}

                {this.state.createOpen && <ClusterDialog open={true}
                                                         handleSave={this.createCluster.bind(this)}
                                                         handleClose={this.closeDialogs.bind(this)}
                />}


                {this.state.aiImportOpen && <AIImportDialog handleClose={this.closeAiImportDialog.bind(this)}/>}

                {this.state.editOpen && <ClusterDialog open={true}
                                                       cluster={this.state.editCluster}
                                                       handleSave={this.updateCluster.bind(this)}
                                                       handleClose={this.closeDialogs.bind(this)}
                />}

                {this.props.auth.user.premium && this.state.shareOpen && <ClusterShareDialog open={true}
                                                                                             cluster={this.state.editCluster}
                                                                                             handleClose={this.closeDialogs.bind(this)}
                />}

                <Menu
                    id="simple-menu"
                    anchorEl={this.state.menuAnchorEl}
                    keepMounted
                    open={Boolean(this.state.menuAnchorEl)}
                    onClose={this.closeMenu.bind(this)}
                >
                    <MenuItem onClick={this.openImportDialog.bind(this)}
                              disabled={this.state.editCluster && this.state.editCluster.shared_by !== null}>Import</MenuItem>
                    <MenuItem onClick={this.exportCluster.bind(this)}
                              disabled={this.state.editCluster && this.state.editCluster.shared_by !== null}>Export</MenuItem>

                    <MenuItem onClick={this.openEditDialog.bind(this)}
                              disabled={this.state.editCluster && this.state.editCluster.shared_by !== null}>Configure</MenuItem>

                    {
                        this.state.editCluster && this.state.editCluster.shared_by == null &&
                        <span>
                            {!(this.state.editCluster && this.state.editCluster.shared_by == null && this.props.auth.user.premium) &&
                                <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                                         title={<Typography>Upgrade to <span
                                             style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                             onClick={() => {
                                                 this.props.history.push('/premium')
                                             }}>PREMIUM</span> to Share!</Typography>}
                                         placement="left" interactive>
                                    <li style={{cursor: "auto", pointerEvents: "all"}}
                                        className={classes.disabled_menu}>Share
                                    </li>
                                </Tooltip>}
                            {this.state.editCluster && this.state.editCluster.shared_by == null && this.props.auth.user.premium &&
                                <MenuItem onClick={this.openShareDialog.bind(this)}>Share</MenuItem>}
                        </span>
                    }
                    <MenuItem onClick={this.removeCluster.bind(this)}
                              disabled={this.state.editCluster && this.state.editCluster.shared_by !== null}>Remove</MenuItem>
                    {this.state.editCluster && this.state.editCluster.shared_by !== null &&
                        <MenuItem onClick={this.openCancelShareDialog.bind(this)}>Cancel share</MenuItem>}
                </Menu>

                {active_clusters_count >= 3 && !this.props.auth.user.premium &&
                    <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                             PopperProps={{
                                 style: {maxWidth: "70vw"}
                             }}
                             title={<Typography>Upgrade to <span
                                 style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                 onClick={() => {
                                     this.props.history.push('/premium')
                                 }}>PREMIUM</span> with No Limit of Clusters!</Typography>}
                             placement="left" interactive>
                        <div className={classes.fab}>
                            <Fab color="primary" disabled={true}>
                                <AddIcon/>
                            </Fab>
                        </div>
                    </Tooltip>}
                {this.props.auth.user.ai_available &&
                    <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                             PopperProps={{
                                 style: {maxWidth: "70vw"}
                             }}
                             title={<Typography>Ask A. I. Teacher</Typography>}
                             placement="left" interactive>
                        <Fab color="primary" className={classes.fab2}
                     disabled={this.state.aiImportOpen}
                     onClick={this.openAiImportDialog.bind(this)}>
                    <PsychologyIcon/>
                        </Fab>
                    </Tooltip>}
                {!this.props.auth.user.ai_available &&
                    <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                             PopperProps={{
                                 style: {maxWidth: "70vw"}
                             }}
                             title={<Typography>Upgrade to <span
                                 style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                 onClick={() => {
                                     this.props.history.push('/premium')
                                 }}>PREMIUM</span> to ask A. I. Teacher!</Typography>}
                             placement="left" interactive>
                        <div className={classes.fab2}>
                            <Fab color="primary" disabled={true}>
                                <PsychologyIcon/>
                            </Fab>
                        </div>
                    </Tooltip>}
                {!(active_clusters_count >= 3 && !this.props.auth.user.premium) &&
                    <Fab color="primary" className={classes.fab}
                         onClick={this.openCreateDialog.bind(this)}>
                        <AddIcon/>
                    </Fab>}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    test: state.test,
    clusters: state.clusters.clusters,
    is_logged: state.auth.is_logged,
    error: state.clusters.error,
    theming: state.theming
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {
        set_page_title,
        get_clusters,
        update_cluster,
        create_cluster,
        remove_cluster,
        clear_cluster_error,
        resume_test,
        cancel_share
    }
)(Clusters)));
